import React, { useState } from "react";
import { Button } from "@/components/ui/button";

export default function EditTodoForm({ todo, onSave, onCancel }) {
  const [text, setText] = useState(todo.text || '');
  const [priority, setPriority] = useState(todo.priority || 5);
  const [dueDate, setDueDate] = useState(todo.dueDate || '');
  const [note, setNote] = useState(todo.note || '');

  const handleSave = () => {
    if (!text.trim()) return;
    onSave({ text: text.trim(), priority, dueDate, note });
  };

  return (
    <div className="space-y-4">
      <div>
        <label className="text-sm font-medium text-slate-700">Aufgabe</label>
        <input type="text" value={text} onChange={e => setText(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && handleSave()}
          className="w-full mt-1 p-3 border border-slate-200 rounded-lg text-sm" autoFocus />
      </div>
      <div>
        <label className="text-sm font-medium text-slate-700">Priorität: {priority}</label>
        <input type="range" min="1" max="10" value={priority}
          onChange={e => setPriority(parseInt(e.target.value))}
          className="w-full mt-1 accent-purple-600" />
        <div className="flex justify-between text-xs text-slate-500">
          <span>1 (niedrig)</span><span>10 (hoch)</span>
        </div>
      </div>
      <div>
        <label className="text-sm font-medium text-slate-700">Fällig bis (optional)</label>
        <input type="date" value={dueDate} onChange={e => setDueDate(e.target.value)}
          className="w-full mt-1 p-3 border border-slate-200 rounded-lg text-sm" />
      </div>
      <div>
        <label className="text-sm font-medium text-slate-700">Notizen (optional)</label>
        <textarea value={note} onChange={e => setNote(e.target.value)}
          placeholder="Zusätzliche Infos..."
          className="w-full mt-1 p-3 border border-slate-200 rounded-lg text-sm resize-none" rows={2} />
      </div>
      <div className="flex gap-2 pt-2">
        <Button onClick={handleSave} className="flex-1 bg-purple-600 hover:bg-purple-700">Speichern</Button>
        <Button onClick={onCancel} variant="outline">Abbrechen</Button>
      </div>
    </div>
  );
}
